module.exports = "//static.hsappstatic.net/pricing-pages-ui-components/static-1.12790/js/productIcon/images/breeze.svg"